
module.exports = () => `gem install flagsmith
`;
